// Note: this is only mapping model level constraints to the columns they affect

import { useMemo } from 'react';

import { ModelAppliedStateNode, ModelLevelConstraint } from '@/__generated__/graphql';

// Column level constraints must be handled in the future
export const useModelConstraints = (
  input: Pick<ModelAppliedStateNode, '__typename' | 'constraints'>,
) => {
  return useMemo(() => {
    if (!input) return;
    const { __typename, constraints } = input;
    if (__typename !== 'ModelAppliedStateNode') return;
    const columnConstraintMap: Record<string, ModelLevelConstraint[] | undefined> = {};
    constraints?.forEach((constraint) => {
      constraint.columns?.forEach((columnName) => {
        if (!columnName) {
          return;
        }
        columnConstraintMap[columnName] ??= [];
        columnConstraintMap[columnName]!.push(constraint);
      });
    });
    return columnConstraintMap;
  }, [input]);
};
